import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PendingBonificiRequest.module.scss';
import dayjs from 'dayjs';
import clx from 'classnames';
import { Bot, Clock3, Inbox } from 'lucide-react';

const PendingBonificiRequest = ({ bonifici }) => {
  const { t } = useTranslation();
  const pendingRequests =
    bonifici?.filter((b) => b.sent === 0 && b.disabled !== 1 && !!b.createdAt) || [];
  const validRequests = bonifici ? bonifici.filter((b) => b.disabled !== 1 && !!b.createdAt) : [];

  const request = pendingRequests[pendingRequests.length - 1];
  const lastRequest = validRequests[validRequests.length - 1];
  const nextAutoRequestInDays = lastRequest
    ? Math.max(0, 20 - dayjs().diff(dayjs(lastRequest.createdAt), 'day'))
    : 20;

  return (
    <div className={styles.wrapper}>
      <div className={clx(styles.container, styles.container_auto)}>
        <span className={styles.icon_wrap} aria-hidden="true">
          <Bot size={18} strokeWidth={2.2} />
        </span>
        <p className={styles.description}>
          {t('payments.pendingRequest.autoMessageLine1')}{' '}
          {t('payments.pendingRequest.autoMessageLine2')}
          <span className={styles.countdown}>
            {t('payments.pendingRequest.nextAutoRequestInDays', { days: nextAutoRequestInDays })}
          </span>
        </p>
      </div>
      <div className={clx(styles.container, { [styles.container_pending]: !!request })}>
        {request ? (
          <>
            <div className={styles.pending_copy}>
              {!!request?.generatedAutomatically && (
                <span className={styles.icon_wrap} aria-hidden="true">
                  <Bot size={18} strokeWidth={2.2} />
                </span>
              )}
              <p className={styles.description}>
                {t('payments.pendingRequest.requestSentOn')}{' '}
                <span className={styles.label}>
                  {dayjs(request.createdAt).format('DD/MM/YYYY HH:mm')}
                </span>
                , {t('payments.pendingRequest.forAmount')}{' '}
                <span className={styles.value_amount}>€ {request.totale}</span>
              </p>
            </div>
            <p className={styles.footer_text}>{t('payments.pendingRequest.footerText')}</p>
          </>
        ) : (
          <div className={styles.pending_copy}>
            <span className={styles.icon_wrap} aria-hidden="true">
              {nextAutoRequestInDays > 0 ? (
                <Clock3 size={18} strokeWidth={2.2} />
              ) : (
                <Inbox size={18} strokeWidth={2.2} />
              )}
            </span>
            <p className={styles.description}>{t('payments.pendingRequest.noPendingRequest')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingBonificiRequest;
